import { createContext, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const Ctx = createContext(null);
export const useAuth = () => useContext(Ctx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  useEffect(() => { http.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false)); }, []);
  const login = async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    localStorage.setItem("n365-token", data.token);
    setUser(data);
  };
  const logout = async () => {
    await http.post("/auth/logout").catch(() => {});
    localStorage.removeItem("n365-token");
    setUser(false);
  };
  return <Ctx.Provider value={{ user, login, logout }}>{children}</Ctx.Provider>;
}
